/**
 * TODO: change this to the project prefix, the project prefix will be used to prefix the resources created in the AWS account.
 * example. if the template has an ssm parameter all ssm parameters will start with /{projectPrefix}/
 */
export const projectPrefix: Readonly<string> = 'ifrs16dc';

export const submissionDeadlineDays: Readonly<number> = 6; // The number of working days before the end of the month when the submission deadline occurs.
